import { Input, OnInit, OnChanges, Component, NgModule, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { Guest } from "app/shared";
import { GuestRole } from "app/shared/models/guest-role.model";
import { ActivatedRoute, Router } from '@angular/router';
import { SponsorService } from "app/shared/services/sponsor.service";

@Component({
    selector: 'app-guest-table',
    templateUrl: './guest-table.component.html',
    styleUrls: ['./guest-table.component.scss'],
    standalone: false
})

export class GuestTableComponent implements OnInit, OnChanges{
    @Input() guests: GuestRole[];
    @Input() includeName: boolean = true;
    @Input() includeSearch: boolean = false;
    displayedColumns: string[] = [ 'createdOn', 'guestName', 'organization', 'roleName', 'startDate', 'endDate', 'active'];
    dataSource: MatTableDataSource<GuestRole>;

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;

  constructor(private route: ActivatedRoute, private sponsorService: SponsorService) {}

    ngOnInit(){
        if (!this.includeName)
        {
            this.displayedColumns = this.displayedColumns.filter(c => c != 'guestName');
        }
    }

    ngOnChanges(){
        if(this.guests) {
          this.dataSource = new MatTableDataSource(this.guests);
          this.dataSource.sort = this.sort
          this.dataSource.paginator = this.paginator;
        }
    }

    applyFilter(filterValue: string) {
      this.dataSource.filterPredicate = (data: any, filterVal: string) => {
        // Split the keywords by spaces so we can individually check them
        const keywords = filterValue.toLowerCase().split(' ');
        // Get the birthdate if it exists
        const dataDate = new Date(data.guest?.birthdate);

        // Create an interface so we can use .includes on the values in the matchAllKewords function
        interface Fields {
          [key: string]: string;
        }

        // Create an object with the fields we want to search
        const fieldsToSearch = {
          name: data.guest?.fullName?.trim().toLowerCase(),
          organization: data?.organization?.trim().toLowerCase(),
          inumber: data.guest?.iNumber?.trim().toLowerCase(),
          // Format as multiple variations of dates so we can search by any of them
          // Example: 01/01/2023, 1/1/2023, 01/1/2023
          birthdate: dataDate ? dataDate.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' })
            + "," + dataDate.toLocaleDateString('en-US')
            + "," + dataDate.toLocaleDateString('en-US', { month: '2-digit', day: 'numeric', year: 'numeric' })
            : ''
        }

        // match all keywords with some of the fields in each guest
        function matchAllKeywords(keywords: string[], fields: Fields) {
          const unmatched = keywords.filter(keyword => {
            return !Object.values(fields).some(value => {
              return value.includes(keyword);
            });
          });

          return unmatched.length === 0;
        }

        // returns true if all keywords are found in any of the fields
        return matchAllKeywords(keywords, fieldsToSearch);
      }
      // trim and lowercase the input to send to the predicate filtering
      this.dataSource.filter = filterValue.trim().toLowerCase();

  }

}